import { API_BASE_URL } from '@/constants/AppConfig'

export const fetchConfig = async (
  url: string,
  verb?: string,
  revalidate?: number,
  body?: any,
  headers?: {
    'Content-Type': 'application/json'
  },
  tags?: string[] // Cache tags for grouped revalidation
) => {
  try {
    verb = verb || 'GET'
    revalidate = revalidate || 0

    // Configure caching based on revalidate parameter
    const fetchOptions: RequestInit = {
      method: verb,
      headers: headers,
      body: body ? JSON.stringify(body) : undefined,
    }

    // Add timeout for faster failure detection
    const controller = new AbortController()
    const timeoutId = setTimeout(() => controller.abort(), 10000) // 10 second timeout
    fetchOptions.signal = controller.signal

    // If revalidate is 0, disable caching (no-store)
    // If revalidate is greater than 0, enable caching with Next.js revalidation
    if (revalidate === 0) {
      fetchOptions.cache = 'no-store' // Disable caching to always fetch fresh data
    } else {
      fetchOptions.next = {
        revalidate: revalidate, // Cache for specified seconds
        tags: tags, // Cache tags for grouped revalidation
      }
    }

    const response = await fetch(API_BASE_URL + url, fetchOptions)
    clearTimeout(timeoutId) // Clear timeout on successful response

    if (!response.ok) {
      console.error('Failed to fetch:', response.status, response.statusText, url)
      throw new Error(`HTTP ${response.status}: ${response.statusText}`)
    }
    return await response.json()
  } catch (error) {
    if (error instanceof Error && error.name === 'AbortError') {
      console.error('Request timeout for:', url)
      throw new Error('Request timeout')
    }
    console.error('Error fetching config:', error)
    throw error // Re-throw to allow proper error handling upstream
  }
}
